import Account from 'components/Controller/Account'
import { Navigate } from 'react-router-dom'
import CreateStudent from './CreateStudent'
import Student from './Student'
import UpdateStudent from './UpdateStudent'
const Students = [
	{
		path: 'account',
		element: <Navigate to='account/students' />,
	},
	{
		path: 'account/students',
		element: (
			<Account>
				<Student />
			</Account>
		),
	},
	{
		path: 'account/students/create',
		element: (
			<Account>
				<CreateStudent />
			</Account>
		),
	},
	{
		path: 'account/students/update/:id',
		element: (
			<Account>
				<UpdateStudent />
			</Account>
		),
	},
]
export default Students
